import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Table,
  Button,
  Modal,
  Form,
  Alert,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../AuthContext.js";
import {
  buscarEmpleadosAdministrador,
  buscarLocalAdmin,
  bloquearUsuario,
  habilitarUsuario,
} from "../../../service/ObtenerLocalesAdmin.js";
import {
  mensajeError,
  mensajeErrorNoAutorizado,
  mensajeErrorSesion,
} from "../../../helpers/mensajesSwalError.js";
import CargandoComponente from "../../../componentes/cargando/CargandoComponentes.js";
import Carga from "../../../componentes/cargando/Cargando.js";
import { buscarAdministradorPorIdService } from "../../../service/dueno/buscarEmpleados.js";
import CargaMedia from "../../../componentes/cargando/CargandoMedio.js";
import {buscarPermisosServicios, buscarPermisosUsuarioServicios} from "../../../service/dueno/buscarPermisos";
import {guardarPermisosServicios} from "../../../service/dueno/salvarPermisos";
import "../../../static/css/adminAdministradorDueno.css"
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { BiLock, BiEdit, BiUserCheck, BiShow } from "react-icons/bi";

const ListaAdministrador = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [locales, setLocales] = useState([]);
  const [localSeleccionado, setLocalSeleccionado] = useState("");
  const { verificacionToken, removerLocalStorage } = useAuth();
  const [cargandoUsuario, setCargandoUsuario] = useState(true);
  const [cargandoLocal, setCargandoLocal] = useState(true);

  const [nuevoEmpleadoEmail, setNuevoEmpleadoEmail] = useState("");
  const [nuevoEmpleadoNombre, setNuevoEmpleadoNombre] = useState("");
  const [nuevoEmpleadoApellido, setNuevoEmpleadoApellido] = useState("");
  const [nuevoEmpleadoRut, setNuevoEmpleadoRut] = useState("");
  const [nuevoEmpleadoNumero, setNuevoEmpleadoNumero] = useState("");

  const [showModalEditar, setShowModalEditar] = useState(false);
  const [cargandoEditarEmpleado, setCargandoEditarEmpleado] = useState(true);
  const [editarEmpleadoNombre, setEditarEmpleadoNombre] = useState("");
  const [editarEmpleadoApellido, setEditarEmpleadoApellido] = useState("");
  const [editarEmpleadoNumero, setEditarEmpleadoNumero] = useState("");
  const [editarLocalSeleccionado, setEditarLocalSeleccionado] = useState("");
  const [editarEmpleadoId, setEditarEmpleadoId] = useState(0)

  const [permisos , setPermisos] = useState([]);
  const [permisosUsuarios, setPermisosUsuarios] = useState([]);
  const [showModalPermiso, setShowModalPermiso] = useState(false);
  const [permisoUsuarioId, setPermisoUsuarioId] = useState(0);

  const navigate = useNavigate();

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleNavigate = () => {
    handleClose();
  };

  useEffect(() => {
    verificacionToken("ROLE_DUENO");
    buscarLocal();
    buscarEmpleado();
    buscarPermisosUsuario()
    setLoading(false);
  }, []);

  //buscar Permisos
  const buscarPermisosUsuario = async () => {
    const permisos = await buscarPermisosServicios()
    if (!permisos[0]) {
      if (permisos[3] === 401) {
        removerLocalStorage();
        mensajeErrorSesion();
      } else if (permisos[3] === 403) {
        removerLocalStorage();
        mensajeErrorNoAutorizado();
      } else {
        removerLocalStorage();
        mensajeError();
      }
    } else {
      setPermisos(permisos[1]);
      setCargandoUsuario(false);
    }
  }

  //buscar empleados
  const buscarEmpleado = async () => {
    const respuestaEmpleados = await buscarEmpleadosAdministrador();

    if (!respuestaEmpleados[0]) {
      if (respuestaEmpleados[3] === 401) {
        removerLocalStorage();
        mensajeErrorSesion();
      } else if (respuestaEmpleados[3] === 403) {
        removerLocalStorage();
        mensajeErrorNoAutorizado();
      } else {
        removerLocalStorage();
        mensajeError();
      }
    } else {
      setEmployees(respuestaEmpleados[1]);
      setCargandoUsuario(false);
    }
  };

  //buscar locales
  const buscarLocal = async () => {
    const respuestaLocal = await buscarLocalAdmin();

    if (!respuestaLocal[0]) {
      if (respuestaLocal[2] === 401) {
        removerLocalStorage();
        mensajeErrorSesion();
      } else if (respuestaLocal[2] === 403) {
        removerLocalStorage();
        mensajeErrorNoAutorizado();
      } else {
        removerLocalStorage();
        mensajeError();
      }
    } else {
      setLocales(respuestaLocal[1]);
      setCargandoLocal(false);
    }
  };

  const verVentasEmpleados = async (id) => {
    console.log(id);
  };

  const handleBlock = async (id) => {
    const bloquearUsuarioHandler = await bloquearUsuario(id);
    if (bloquearUsuarioHandler[0]) {
      setEmployees(
        employees.map((emp) =>
          emp.id === id ? { ...emp, estado: false } : emp
        )
      );
    }
  };

  const handleUnblock = async (id) => {
    const habilitarUsuarioHandler = await habilitarUsuario(id);
    if (habilitarUsuarioHandler[0]) {
      setEmployees(
        employees.map((emp) => (emp.id === id ? { ...emp, estado: true } : emp))
      );
    }
  };

  const handleAddEmployee = async () => {
    Swal.fire({
      title: "Quieres agregar un Administrador?",
      showCancelButton: true,
      confirmButtonText: "Agregar",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Agregando empleado...",
          text: "Por favor, espere un momento.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading(); // Muestra el loading spinner
          },
        });
        const add = async () => {
          const campos = [
            { valor: nuevoEmpleadoEmail, nombre: "Email" },
            { valor: nuevoEmpleadoRut, nombre: "Rut" },
            { valor: nuevoEmpleadoNombre, nombre: "Nombre" },
            { valor: nuevoEmpleadoApellido, nombre: "Apellido" },
            { valor: nuevoEmpleadoNumero, nombre: "Número" },
          ];

          for (let campo of campos) {
            if (campo.valor.trim() === "") {
              return Swal.fire({
                title: "Error",
                text: `No puede estar vacío el campo ${campo.nombre}`,
                icon: "error",
              });
            }
          }

          if (localSeleccionado == 0) {
            return Swal.fire({
              title: "Error",
              text: `Seleccione un local`,
              icon: "error",
            });
          }

          const token = localStorage.getItem("token");
          const config = {
            headers: {
              Authorization: `${token}`,
            },
          };
          try {
            await axios.post(
              `${process.env.REACT_APP_API_URL}/administrador/empleados/agregar`,
              {
                email: nuevoEmpleadoEmail,
                rut: nuevoEmpleadoRut,
                nombre: nuevoEmpleadoNombre,
                apellido: nuevoEmpleadoApellido,
                numero: nuevoEmpleadoNumero,
                local_id: localSeleccionado,
              },
              config
            );
            await buscarEmpleado();
            setShowModal(false);
            setNuevoEmpleadoEmail("");
            return Swal.fire({
              title: "Agregado!",
              text: "Se ha agregado con exito el Administrador",
              icon: "success",
            });
          } catch (error) {
            console.log(error);
            if (error.status === 406) {
              return Swal.fire({
                title: "Error",
                text: "El correo o el rut ya estan registrado",
                icon: "error",
              });
            } else if (error.status === 403) {
              navigate("/no-autorizado");
            } else {
              return Swal.fire({
                title: "Error",
                text: "Ocurrió un problema al agregar el empleado",
                icon: "error",
              });
            }
          }
        };
        add();
      }
    });
  };

  const handleEditEmployee = async () => {
    Swal.fire({
      title: "Quieres editar el Administrador?",
      showCancelButton: true,
      confirmButtonText: "Editar",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Editando empleado...",
          text: "Por favor, espere un momento.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading(); // Muestra el loading spinner
          },
        });
        const add = async () => {
          const campos = [
            { valor: editarEmpleadoNombre, nombre: "Nombre" },
            { valor: editarEmpleadoApellido, nombre: "Apellido" },
            { valor: editarEmpleadoNumero, nombre: "Número" },
          ];

          for (let campo of campos) {
            if (campo.valor.trim() === "") {
              return Swal.fire({
                title: "Error",
                text: `No puede estar vacío el campo ${campo.nombre}`,
                icon: "error",
              });
            }
          }

          if (editarLocalSeleccionado == 0) {
            return Swal.fire({
              title: "Error",
              text: `Seleccione un local`,
              icon: "error",
            });
          }

          const token = localStorage.getItem("token");
          const config = {
            headers: {
              Authorization: `${token}`,
            },
          };
          try {
            await axios.put(
              `${process.env.REACT_APP_API_URL}/administrador/empleados/agregar/${editarEmpleadoId}`,
              {
                nombre: editarEmpleadoNombre,
                apellido: editarEmpleadoApellido,
                numero: editarEmpleadoNumero,
                local_id: editarLocalSeleccionado,
              },
              config
            );
            await buscarEmpleado();
            setShowModal(false);
            return Swal.fire({
              title: "Agregado!",
              text: "Se ha editado con exito el Administrador",
              icon: "success",
            });
          } catch (error) {
            console.log(error);
            if (error.status === 406) {
              return Swal.fire({
                title: "Error",
                text: "El correo o el rut ya estan registrado",
                icon: "error",
              });
            } else if (error.status === 403) {
              navigate("/no-autorizado");
            } else {
              return Swal.fire({
                title: "Error",
                text: "Ocurrió un problema al agregar el empleado",
                icon: "error",
              });
            }
          }
        };
        add();
      }
    });
  };

  const agregarPermisosEmpleados = async (id) => {
    const permisosUsuarioBD = await buscarPermisosUsuarioServicios(id)

    if (!permisosUsuarioBD[0]) {
      if (permisosUsuarioBD[3] === 401) {
        removerLocalStorage();
        mensajeErrorSesion();
      } else if (permisosUsuarioBD[3] === 403) {
        removerLocalStorage();
        mensajeErrorNoAutorizado();
      } else {
        removerLocalStorage();
        mensajeError();
      }
    } else {
      setPermisoUsuarioId(id)
      setPermisosUsuarios(permisosUsuarioBD[1]);
      setCargandoUsuario(false);
      setShowModalPermiso(true)
    }
  }

  const togglePermiso = (permisoId) => {
    if (permisosUsuarios.includes(permisoId)) {
      setPermisosUsuarios(permisosUsuarios.filter((id) => id !== permisoId));
    } else {
      setPermisosUsuarios([...permisosUsuarios, permisoId]);
    }
  };

  const openHandlerEdit = (id) => {
    setShowModalEditar(true);
    buscarAdministradores(id);
  };

  const buscarAdministradores = async (id) => {
    const respuesta = await buscarAdministradorPorIdService(id);

    if (respuesta[0]) {
      setEditarEmpleadoNombre(respuesta[1].perfil.nombres);
      setEditarEmpleadoApellido(respuesta[1].perfil.apellidos);
      setEditarEmpleadoNumero(respuesta[1].perfil.numero);
      setEditarLocalSeleccionado(respuesta[1].local_id);
      setEditarEmpleadoId(respuesta[1].id)
    }
    setCargandoEditarEmpleado(false);
  };

  const handleGuardarPermisos = async () => {
    Swal.fire({
      title: "Editando empleado...",
      text: "Por favor, espere un momento.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading(); // Muestra el loading spinner
      },
    });
    const respuesta = await guardarPermisosServicios(permisoUsuarioId, permisosUsuarios)
    if (!respuesta[0]) {
      if (respuesta[3] === 401) {
        removerLocalStorage();
        mensajeErrorSesion();
      } else if (respuesta[3] === 403) {
        removerLocalStorage();
        mensajeErrorNoAutorizado();
      } else {
        removerLocalStorage();
        mensajeError();
      }
    } else {
      setPermisosUsuarios(respuesta[1]);
      setPermisoUsuarioId(0)
      setShowModalPermiso(false)
      Swal.fire({
        title: "Agregado!",
        text: "Se ha editado con exito los permisos",
        icon: "success",
      })
    }
  }

  const cerrarEditor = () => {
    setShowModalEditar(false);
    setCargandoEditarEmpleado(true);
  };

  const cerrarPermiso = () => {
    setShowModalPermiso(false);
    setPermisosUsuarios([])
    setPermisoUsuarioId(0)
  };

  if (loading) {
    return <Carga />;
  }

  return (
    <div className="container mt-5 pb-5">
      <div className="row align-items-center mb-3">
        <h2 className="col-8">Lista de Administrador</h2>
        {cargandoLocal ? (
          <CargandoComponente />
        ) : (
          <Button
            className="col-auto"
            variant="btn btn-outline-primary"
            onClick={() => setShowModal(true)}
          >
            Agregar Administrador
          </Button>
        )}
      </div>
      {cargandoUsuario ? (
        <CargandoComponente />
      ) : (
        <div>
          {employees.length === 0 ? (
            <Container>
              <Row className="justify-content-center">
                <Col xs={12} sm={10} md={8} lg={6}>
                  <Alert variant="warning" className="text-center mt-4">
                    <Alert.Heading>¡Atención!</Alert.Heading>
                    <p>No hay administradores disponibles en este momento.</p>
                  </Alert>
                </Col>
              </Row>
            </Container>
          ) : (
              <div className="table-responsive">
                <table className="table table-striped table-hover align-middle">
                  <thead className="table-header-rosa">
                  <tr>
                    <th className="text-center" >Ventas</th>
                    <th className="text-center">Nombre</th>
                    <th className="text-center">Local</th>
                    <th className="text-center">Estado</th>
                    <th className="text-center">Editar</th>
                    <th className="text-center">Permisos</th>
                  </tr>
                  </thead>
                  <tbody>
                  {employees.map((employee) => (
                      <tr key={employee.id}>
                        <td className="text-center">
                          <button
                              className="btn-rosa-outline"
                              onClick={() => verVentasEmpleados(employee.id)}
                          >
                            💰
                          </button>
                        </td>
                        <td className="text-center">{employee.perfil.nombre} {employee.perfil.apellido}</td>
                        <td className="text-center">{employee.local}</td>

                        <td className="text-center">
                          <button
                              className={`btn ${employee.estado ? "btn-rosa-outline-danger" : "btn-rosa-outline-success"}`}
                              title={employee.estado?'Usuario Habilitado':'Usuario Bloqueado'}
                              onClick={() => {
                                if (employee.estado) {
                                  handleBlock(employee.id);
                                } else {
                                  handleUnblock(employee.id);
                                }
                              }}
                          >
                            {employee.estado ? "✅" : "⛔"}</button>
                        </td>

                          <td className="text-center">
                          <button
                              className="btn btn-rosa-outline"
                              onClick={() => openHandlerEdit(employee.id)}
                          >
                            ✏️
                          </button
                          ></td>
                        <td className="text-center">
                          <button
                              className="btn btn-rosa-outline"
                              onClick={() => agregarPermisosEmpleados(employee.id)}
                          >
                            🔑
                          </button>
                        </td>
                      </tr>
                  ))}
                  </tbody>
                </table>
              </div>
          )}
        </div>
      )}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Nuevo Administrador</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formEmployeeName">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Ingrese un email"
                value={nuevoEmpleadoEmail}
                onChange={(e) => setNuevoEmpleadoEmail(e.target.value)}
              />
              <Form.Label>Rut</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ingrese un rut o indentificador"
                value={nuevoEmpleadoRut}
                onChange={(e) => setNuevoEmpleadoRut(e.target.value)}
              />
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ingrese un nombre"
                value={nuevoEmpleadoNombre}
                onChange={(e) => setNuevoEmpleadoNombre(e.target.value)}
              />
              <Form.Label>Apellido</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ingrese un apellido"
                value={nuevoEmpleadoApellido}
                onChange={(e) => setNuevoEmpleadoApellido(e.target.value)}
              />
              <Form.Label>Teléfono</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ingrese un número"
                value={nuevoEmpleadoNumero}
                onChange={(e) => setNuevoEmpleadoNumero(e.target.value)}
              />
              <Form.Control
                as="select"
                value={localSeleccionado}
                onChange={(e) => setLocalSeleccionado(e.target.value)}
              >
                <option value="">Seleccione un local</option>
                {locales.map((local) => (
                  <option key={local.id} value={local.id}>
                    {local.nombres}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="btn btn-outline-success" onClick={handleAddEmployee}>
            Agregar
          </Button>
          <Button
            variant="btn btn-outline-danger"
            onClick={() => setShowModal(false)}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showModalEditar} onHide={() => cerrarEditor()}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Administrador</Modal.Title>
        </Modal.Header>
        {cargandoEditarEmpleado ? (
          <div className="py-2"><CargaMedia/></div>
        ) : (
          <>
            <Modal.Body>
              <Form>
                <Form.Group controlId="formEmployeeNameEdit">
                  <Form.Label>Nombre</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ingrese un nombre"
                    value={editarEmpleadoNombre}
                    onChange={(e) => setEditarEmpleadoNombre(e.target.value)}
                  />
                  <Form.Label>Apellido</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ingrese un apellido"
                    value={editarEmpleadoApellido}
                    onChange={(e) => setEditarEmpleadoApellido(e.target.value)}
                  />
                  <Form.Label>Teléfono</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ingrese un número"
                    value={editarEmpleadoNumero}
                    onChange={(e) => setEditarEmpleadoNumero(e.target.value)}
                  />
                  <Form.Label>Elige un Local</Form.Label>
                  <Form.Control
                    as="select"
                    value={editarLocalSeleccionado}
                    onChange={(e) => setEditarLocalSeleccionado(e.target.value)}
                  >
                    {locales.map((local) => (
                      <option key={local.id} value={local.id}>
                        {local.nombres}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="btn btn-outline-success"
                onClick={handleEditEmployee}
              >
                Editar
              </Button>
              <Button
                variant="btn btn-outline-danger"
                onClick={() => cerrarEditor(false)}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </>
        )}
      </Modal>

      <Modal
          show={showModalPermiso}
          onHide={() => cerrarPermiso()}
          centered
          size="lg"
      >
        <Modal.Header
            closeButton
            className="bg-primary text-white justify-content-center position-relative"
        >
          <Modal.Title className="text-center w-100">
            <i className="bi bi-shield-lock-fill me-2"></i>
            Permisos del Usuario
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
          <div className="mb-3">
            <h6 className="text-secondary fw-semibold border-bottom pb-2">
              Selecciona los permisos que deseas asignar:
            </h6>
          </div>

          <Form>
            <div className="row">
              {permisos.map((permiso) => (
                  <div key={permiso.id} className="col-md-6 mb-2">
                    <Form.Check
                        type="switch"
                        id={`permiso-${permiso.id}`}
                        label={permiso.nombre}
                        checked={permisosUsuarios.includes(permiso.id)}
                        onChange={() => togglePermiso(permiso.id)}
                        className="fw-semibold"
                    />
                  </div>
              ))}
            </div>
          </Form>
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-between">
          <Button
              variant="outline-secondary"
              onClick={() => cerrarPermiso()}
          >
            <i className="bi bi-x-circle me-1"></i> Cancelar
          </Button>

          <Button variant="success" onClick={handleGuardarPermisos}>
            <i className="bi bi-check-circle me-1"></i> Guardar cambios
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default ListaAdministrador;
